<template>
    <v-container>
        <v-row>
            <v-col>
                <v-toolbar dense elevation="1" rounded color="secondary">
                    <v-breadcrumbs class="ms-n6" :items="[{text: 'Purchasing & Ordering'}, {text: 'Ordering'} ,{text: 'Edit Supplier Group',}]" large/>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-sheet elevation="1" rounded>
                    <v-toolbar flat color="secondary">
                        <v-toolbar-title>
                            Edit Supplier Group
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <PIconBtn icon="mdi-content-save" tooltip="Save" @click="handleSave"/>
                            <PIconBtn icon="mdi-delete" tooltip="Delete" @click="handleDelete" v-if="hasPermission(perm.supplier_group.delete)"/>
                            <PIconBtn icon="mdi-cancel" tooltip="Discard" @click="handleDiscard"/>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <SupplierGroupForm class="ma-2" v-if="!loading" ref="form" v-model="form" @submit="handleSubmit"/>
                </v-sheet>
            </v-col>
        </v-row>
        <PAlert v-model="alert.value" v-bind="alert"></PAlert>
        <LoadingOverlay :value="loading"/>
    </v-container>
</template>

<script>
import permissions from './../../data/permissions';
import LoadingOverlay from './../../components/common/LoadingOverlay.vue'
import { mapActions, mapGetters } from 'vuex'
import PAlert from './../../components/common/PAlert.vue'
import PIconBtn from './../../components/common/PIconBtn.vue'
import SupplierGroupForm from './../../components/purchase/SupplierGroupForm'
export default {
    name: "SupplierGroupEditView",
    components: {
        SupplierGroupForm,
        PIconBtn,
        PAlert,
        LoadingOverlay
    },
    data() {
        return {
            alert: {
                title: "Alert",
                content: "Are you sure",
                value:  false,
                callback: null
            },
            loading: false,
            form: {},
            id: null,
            confirmBeforeLeave: true,
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            snackbar: "ui/snackbar/show",
            update: "purchase/supplierGroup/update",
            findByID: "purchase/supplierGroup/findByID",
            deleteByID: "purchase/supplierGroup/deleteByID",
        }),
        handleSave() {
            this.$refs.form.submit()
        },
        handleList() {
            this.$router.push({ name: "SupplierGroupList" })
        },
        handleSubmit() {
            this.alert = {...this.alert , value: true, content: "Are you sure you Want to save", callback: this.save}
        },
        fetchSupplierGroup() {
            this.loading = true;
            this.findByID(this.id).then(response => {
                this.form = response.data;
            }).catch(error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({ text: message , color: "error"})
            }).finally(() => {
                this.loading = false;
            });
        },
        save() {
            this.loading = true
            this.update(this.form).then(response => {
                this.confirmBeforeLeave = false;
                this.snackbar({text: "Supplier Group Create", color: "success"})
                this.$router.push({name: "SupplierGroupDisplay", params: { id: response.data.id}})
            }).catch(error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({ text: message , color: "error"})
            }).finally(() => {
                this.loading = false
            })
        },
        handleDiscard() {
            this.alert = {...this.alert , value: true, content: "Are you sure you want to leave this page?", callback: this.discard}
        },
        discard() {
            this.$router.push({ name: "SupplierGroupDisplay", params: { id: this.id } });
        },
        handleDelete() {
            this.alert = {...this.alert , value: true, content: "Are you sure you want to delete", callback: this.delete}
        },
        delete() {
            this.loading = true;
            this.deleteByID(this.id).then(() => {
                this.snackbar({text: "Supplier Group Deleted", color: "success"})
                this.$router.push({ name: "SupplierGroupList"})
            }).catch(error => {
                let message = error.response? error.response.data.message : error;
                this.snackbar({ text: message, color: "error"})
            }).finally(() => {
                this.loading = false;
            })
        },
    },
    mounted() {
        this.id = this.$route.params.id;
        this.fetchSupplierGroup();
    },
    beforeRouteUpdate(to, from, next) {
        this.id = to.params.id;
        this.fetchSupplierGroup();
        next();
    }
}
</script>

<style>

</style>